import React from 'react';
import { compose, graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { injectIntl } from 'react-intl';
import { Helmet } from 'react-helmet';
import { ToastContainer, toast } from 'react-toastify';
import {
  Modal,
  Form,
  Button,
  Dropdown,
  Message,
  Segment,
} from 'semantic-ui-react';

import { REGISTERED_COMPLETE_PROFILE } from 'config/constants';

import USER_QUERY from './graphql/userQuery.gql';

const MainLayout = (Component) => {
  class Layout extends React.Component {
    state = {
      country_id: 1,
      newMember: false,
      modal_errors: [],
      loading: false,
      guestMutated: false,
    };

    componentWillMount() {
      localStorage.removeItem(REGISTERED_COMPLETE_PROFILE);
    }

    componentDidMount() {
      // getting UTM parameters and saving them to users local storage
      if (location.search.includes('utm')) {
        // const UTMS = queryString.parse(location.search);
        // this.setState({ utms: UTMS });
        if (
          !localStorage.latestUTM ||
          localStorage.latestUTM !== location.search
        ) {
          localStorage.setItem('latestUtm', location.search);
        }
      }
      // if (process.env.NODE_ENV === 'production') {
      //   gtag('event', 'page_view', {
      //     send_to: 'AW-864689100',
      //     user_id:
      //       !!this.props.userQuery &&
      //       !!this.props.userQuery.user &&
      //       this.props.userQuery.user.id,
      //   });
      // }
    }

    componentWillReceiveProps(nextProps) {
      const { userQuery } = nextProps;
      const { user = {} } = userQuery;

      // eslint-disable-next-line no-console
      console.rollbar.configure({
        payload: {
          person: {
            id: user.id,
            email: user.email,
          },
          currentUser: user,
        },
      });

      this.setState({ newMember: nextProps.firstSignup.isNewMember });

      // Redirect if reseller to business website
      // if (
      //   !!nextProps.userQuery &&
      //   !!nextProps.userQuery.user &&
      //   nextProps.userQuery.user.is_reseller
      // ) {
      //   window.location = 'https://business.lynks.com';
      // }
    }

    notify = () => toast.error('Wow so easy !');

    _confirm = async () => {
      try {
        this.setState({ modal_errors: [] });
        this.setState({ loading: true });
        const result = await this.props.updateAuthUser({
          variables: {
            country_id: this.state.country_id,
          },
        });
        if (result.data.UpdateAuthUser.id) {
          this.props.updateFirstSignup({
            variables: {
              isNewMember: false,
            },
          });
          this.setState({
            newMember: false,
          });
        }
      } catch (e) {
        // console.log(e)
        this.state.modal_errors.push(e.message);
      }
      this.setState({ loading: false });
    };

    render() {
      const { wrappedComponentRef, userQuery, ...remainingProps } = this.props;
      const currentUser = userQuery && userQuery.user ? userQuery.user : false;
      const countryOptions = [
        { key: 'eg', value: 1, text: 'Egypt' },
        { key: 'ksa', value: 421, text: 'Saudi Arabia' },
        { key: 'kw', value: 344, text: 'Kuwait' },
      ];

      // const today = new Date();

      return (
        <div
          dir={`${this.props.intl.locale === 'ar' ? 'rtl' : 'ltr'}`}
          lang={this.props.intl.locale}
        >
          <Helmet
            titleTemplate="%s - Lynks"
            defaultTitle="Lynks | Shop from any online store"
          >
            <meta name="description" content="Shop from any online store" />
          </Helmet>

          <Segment
            style={{ padding: 0, margin: 0 }}
            basic
            disabled={false}
            loading={false}
          >
            <div style={{ flex: 1 }}>
              <Component
                currentUser={currentUser}
                {...remainingProps}
                ref={wrappedComponentRef}
              />
            </div>
          </Segment>

          <Modal
            closeIcon
            dimmer={this.state.newMember}
            open={this.state.newMember}
          >
            <Modal.Content>
              <Message
                hidden={this.state.modal_errors < 1}
                error
                list={this.state.modal_errors}
              />

              <Form>
                <Form.Field>
                  <label htmlFor="presentation">Country</label>
                  <Dropdown
                    placeholder="Select Country"
                    fluid
                    search
                    selection
                    options={countryOptions}
                    value={this.state.country_id}
                    onChange={(e, data) =>
                      this.setState({ country_id: data.value })
                    }
                  />
                </Form.Field>
              </Form>
            </Modal.Content>
            <Modal.Actions>
              <Button
                loading={this.state.loading}
                positive
                icon="checkmark"
                labelPosition="right"
                content="Confirm"
                onClick={this._confirm}
              />
            </Modal.Actions>
          </Modal>

          <ToastContainer
            position="bottom-center"
            rtl={this.props.intl.locale === 'ar'}
          />
        </div>
      );
    }
  }

  const IS_TOKEN = gql`
    query IsToken {
      isToken
    }
  `;
  const IS_LOGGED_IN = gql`
    query IsLoggedIn {
      isLoggedIn
    }
  `;

  const GEO = gql`
    query Geo {
      geo @client {
        countryCode
      }
    }
  `;
  const GUEST = gql`
    mutation guest {
      guest {
        token
      }
    }
  `;

  const UPDATE_GEO = gql`
    mutation updateGeo($countryCode: String!) {
      updateGeo(countryCode: $countryCode) @client
    }
  `;

  const FIRST_SIGNUP = gql`
    query firstSignup {
      firstSignup @client {
        isNewMember
      }
    }
  `;

  const UPDATE_FIRST_SIGNUP = gql`
    mutation updateFirstSignup($isNewMember: Boolean!) {
      updateFirstSignup(isNewMember: $isNewMember) @client
    }
  `;

  const UPDATE_AUTH_USER = gql`
    mutation UpdateAuthUser($country_id: ID!) {
      UpdateAuthUser(country_id: $country_id) {
        id
      }
    }
  `;

  return compose(
    injectIntl,
    // withRouter,
    graphql(IS_TOKEN, {
      options: { fetchPolicy: 'cache-only' },
      props: ({ data: { isToken } }) => ({
        isToken,
      }),
    }),
    graphql(IS_LOGGED_IN, {
      options: { fetchPolicy: 'cache-only' },
      props: ({ data: { isLoggedIn } }) => ({
        isLoggedIn,
      }),
    }),
    graphql(GUEST, {
      name: 'guest',
      options: () => ({
        errorPolicy: 'all',
        onError: () => null,
      }),
    }),
    graphql(FIRST_SIGNUP, {
      options: { fetchPolicy: 'cache-only' },
      props: ({ data: { firstSignup } }) => ({
        firstSignup,
      }),
    }),
    graphql(GEO, {
      options: { fetchPolicy: 'cache-only' },
      props: ({ data: { geo } }) => ({
        geo,
      }),
    }),
    graphql(UPDATE_GEO, { name: 'updateGeo' }),
    graphql(UPDATE_FIRST_SIGNUP, { name: 'updateFirstSignup' }),
    graphql(USER_QUERY, {
      name: 'userQuery',
      skip: (ownProps) => !ownProps.isToken,
    }),
    graphql(UPDATE_AUTH_USER, { name: 'updateAuthUser' })
  )(Layout);
};

export default MainLayout;



// WEBPACK FOOTER //
// ./app/components/BaseLayout/index.js